import React, { useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import { api } from '../../api/client';

const LoginView = ({ onLoginSuccess, sessionExpired }) => {
  const { setCurrentUser } = useAppContext();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async () => {
    if (!email || !password) { setError('Please enter email and password'); return; }
    setIsLoading(true);
    setError('');
    try {
      const response = await api.login({ email, password });
      setCurrentUser(response.user);
      onLoginSuccess();
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#01006A] flex items-center justify-center p-4">
      <div className="absolute inset-0 opacity-5"
        style={{ backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

      <div className="relative bg-white rounded-2xl shadow-2xl p-10 max-w-md w-full">
        <div className="text-center mb-8">
          <img
            src="/mindset_logo.png"
            alt="Mindset logo"
            className="h-20 w-auto object-contain mx-auto mb-5"
          />
          <div className="border-t border-gray-100 pt-5">
            <h1 className="text-xl font-bold text-gray-900">Strategic Foresight Platform</h1>
            <p className="text-gray-500 mt-1 text-sm">Collaborative futures exploration</p>
          </div>
        </div>

        {/* Session expired banner */}
        {sessionExpired && !error && (
          <div className="mb-5 p-3 bg-amber-50 border border-amber-200 rounded-lg text-amber-800 text-sm flex items-center gap-2">
            <span>⏱</span>
            <span>Your session has expired. Please sign in again.</span>
          </div>
        )}

        {error && (
          <div className="mb-5 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
            {error}
          </div>
        )}

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#01006A] focus:border-transparent outline-none"
              placeholder="your.email@example.com"
              autoFocus
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyPress={e => e.key === 'Enter' && handleLogin()}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#01006A] focus:border-transparent outline-none"
              placeholder="••••••••"
            />
          </div>
          <button
            onClick={handleLogin}
            disabled={isLoading}
            className="w-full bg-[#01006A] text-white py-3 rounded-lg font-semibold hover:bg-[#010059] transition-colors disabled:bg-gray-400 mt-2"
          >
            {isLoading ? 'Signing in…' : 'Sign In'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginView;
